import type { ModePref } from '../themes';

interface Props {
  mode: ModePref;
  onChange: (next: ModePref) => void;
}

const ICONS = {
  auto: (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3 v18" />
      <path d="M12 3 A9 9 0 0 0 12 21 Z" fill="currentColor" />
    </svg>
  ),
  light: (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2 M12 20v2 M4.93 4.93l1.41 1.41 M17.66 17.66l1.41 1.41 M2 12h2 M20 12h2 M4.93 19.07l1.41-1.41 M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  dark: (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  ),
};

const OPTIONS: Array<{ id: ModePref; label: string; icon: JSX.Element }> = [
  { id: 'auto', label: 'Auto', icon: ICONS.auto },
  { id: 'light', label: 'Light', icon: ICONS.light },
  { id: 'dark', label: 'Dark', icon: ICONS.dark },
];

export function ModeToggle({ mode, onChange }: Props) {
  return (
    <div className="mode-toggle" role="radiogroup" aria-label="Color mode">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          role="radio"
          aria-checked={mode === o.id}
          className={`mode-opt${mode === o.id ? ' active' : ''}`}
          onClick={() => onChange(o.id)}
          title={o.id === 'auto' ? 'Match system preference' : `Force ${o.label.toLowerCase()} mode`}
        >
          <span className="mode-opt-icon">{o.icon}</span>
          <span className="mode-opt-label">{o.label}</span>
        </button>
      ))}
    </div>
  );
}
